import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { warehousePermissionUrl } from '.';
import { warehousePermissionsActions } from '../';
import { httpService } from '../../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';

function* deleteWarehouseUserSaga(action: ReturnType<typeof warehousePermissionsActions.deleteUser>) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(deleteLogisticsUser, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else {
    yield put(warehousePermissionsActions.removeUser(action.payload));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteWarehouseUser() {
  yield takeEvery(warehousePermissionsActions.deleteUser.match, deleteWarehouseUserSaga);
}

export async function deleteLogisticsUser(data: { sid: string; departmentId: number }): Promise<IApiExecuteRespone> {
  return executeApiRequest(() => httpService.delete(warehousePermissionUrl(data)), false);
}
